import { hasPermissionsToCreateBadge } from '../../../../backend/features/badges/shared';
import { BadgeManagementContext } from '../../../../ui/features/badge-management/contexts/BadgeManagementContext';
import { useStorageGetBadgeTemplate } from '../../../../ui/features/badge-management/hooks/useStorageGetBadgeTemplate';
import { manageBadgesRoutes } from '../../../../ui/features/badge-management/utils/manageBadgesRoutes';
import { BadgeTemplatePreview } from '../../../../ui/features/badge-preview/components/BadgeTemplatePreview';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { StandardCard } from '@juvare/common-web-ui/Cards/StandardCard';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import AddIcon from '@mui/icons-material/Add';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Box, Button, CircularProgress, Divider } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useNavigate } from 'react-router';
import { BadgePreviewContext } from '../../badge-preview/contexts/BadgePreviewContext';
import { showBadgePreviewModal } from '../../badge-preview/utils/showBadgePreviewModal';
export const BadgeTemplatePreviewCard = ({ badgeTemplate }) => {
    const badgePreviewContext = React.useContext(BadgePreviewContext);
    const { t } = useBadgingTranslation();
    const navigate = useNavigate();
    const userState = useUserState();
    const { data: badgeTemplateData, isLoading } = useStorageGetBadgeTemplate(badgeTemplate.id);
    const { isCreateBadgeEnabled } = React.useContext(BadgeManagementContext);
    const handlePreviewClick = () => {
        showBadgePreviewModal(badgePreviewContext, badgeTemplateData);
    };
    const handleCreateBadgeClick = () => {
        navigate(manageBadgesRoutes.createBadge(badgeTemplate.id));
    };
    return (React.createElement(StandardCard, { key: badgeTemplate.id },
        React.createElement(Box, { sx: { p: 2 } },
            React.createElement(Button, { onClick: handlePreviewClick, size: 'small', startIcon: React.createElement(VisibilityOutlinedIcon, { sx: { width: 18, height: 18 }, color: 'info' }), sx: { px: 1, py: 0.5, mb: 2 } }, t('badges.badgeCard.preview')),
            React.createElement(Box, { sx: {
                    aspectRatio: '276/180',
                    overflow: 'hidden',
                    borderStyle: 'solid',
                    borderWidth: 2,
                    borderColor: themeColors.border.main,
                    borderRadius: 1,
                } },
                isLoading && (React.createElement(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' },
                    React.createElement(CircularProgress, null))),
                badgeTemplateData && (React.createElement(BadgeTemplatePreview, { badgeTemplateClassifier: badgeTemplateData, badgeTemplate: badgeTemplateData.data.badgeTemplateFront, formSettings: badgeTemplateData.data.defaultFormSettings, account: badgeTemplateData.data.defaultSampleAccountData }))),
            React.createElement(Typography, { variant: 'h6', sx: { mt: 2 } }, badgeTemplate.columns.name)),
        isCreateBadgeEnabled && hasPermissionsToCreateBadge(userState) && (React.createElement(Box, null,
            React.createElement(Divider, null),
            React.createElement(Button, { sx: { width: '100%', pl: 3, pr: 3 }, onClick: handleCreateBadgeClick, size: 'large', startIcon: React.createElement(AddIcon, null), "aria-label": t('badges.badgeCard.createBadge'), "data-test": 'primary-button' },
                React.createElement(Box, { sx: { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' } }, t('badges.badgeCard.createBadge')))))));
};
